module.exports = __webpack_public_path__ + "static/img/logo.dd5203a.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./static/images/logo.gif
 ** module id = 765
 ** module chunks = 3
 **/